<template>
    <div class="mylistwrap" v-if="isload" @click="moreshow()">
        <div v-if="($common.basic.isarrayexist(infolist))" class="mylist">
            <dl class="avg listheader" v-if="!issmall">

                <dd>{{$common.dicword('course')}}</dd>
                <dd>{{$common.dicword('datetest')}}</dd>
                <dd>{{$common.dicword('checkintime')}}</dd>
                <dd>{{$common.dicword('testtime')}}</dd>
                <dd v-if="!isteaview">{{$common.dicword('stat')}}</dd>
                <dd v-if="!isteaview">{{$common.dicword('grade')}}</dd>
                <dd v-if="isteaview">{{$common.dicword('infoclass')}}</dd>
                <dd v-if="isteaview">{{$common.dicword('learner')}}</dd>
            </dl>
            <div class="listinfo" @click="moreshow()">
                <dl class="avg" v-for="(item,index) in c_infolist" :key="item.id">
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('course',true)}}&nbsp;
                        </span><router-link class="overparent" :to="item.x_course.x_root+item.courseid" :title="$common.langinfo(item.x_course.title,item.x_course.title_en)"><ffoverdot :title="item.x_course.title" :title_en="item.x_course.title_en" :needtitle="false"></ffoverdot></router-link>
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('datetest',true)}}&nbsp;
                        </span>
                        {{$common.basic.dateformat(item.datefinal)}}
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('checkintime',true)}}&nbsp;
                        </span>
                        {{$common.basic.chint2timewithsecond(item.timeenter)}}
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('testtime',true)}}&nbsp;
                        </span>
                        {{$common.basic.chint2timewithsecond(item.timebegin) +'-'+$common.basic.chint2timewithsecond(item.timeend)}}
                    </dd>
                    <dd v-if="!isteaview">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('stat',true)}}&nbsp;
                        </span>
                        <a href="#" class="listbtn" v-if="$store.getters.isstu &&!item.x_isexam && item.finalstat==4" @click="gototest(item.id)">
                            {{$common.dicword('gototest')}}
                        </a>
                        <template v-else>
                            {{$common.langinfo(item.x_statitem.title,item.x_statitem.title_en)}}
                        </template>


                    </dd>
                    <dd v-if="!isteaview">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('infoclass',true)}}&nbsp;
                        </span>
                        {{item.x_mem.isexam?item.x_mem.examgrade:'-'}}
                    </dd>
                    <dd v-else-if="isteaview" class="ztwrap">
                        <template v-if="issmall">
                            <span class="smalltitle">
                                {{$common.dicword('infoclass',true)}} &nbsp;
                            </span>
                            <span>
                                <span v-for="(item2,index2) in item.x_groups" :key="index2">
                                    {{$common.langinfo(item2.title,item2.title_en)}}
                                </span>

                            </span>
                        </template>
                        <template v-else>
                            <span :class="[item.x_groupshow?'ztshow':'zt']" @mouseover="item.x_groupshow=item.x_groups.length>1" @mouseout="item.x_groupshow=false">

                                <span v-for="(item2,index2) in item.x_groups" :key="index2">
                                    {{$common.langinfo(item2.title,item2.title_en)}}
                                    <i :class="[(item.x_groups.length>1 && index2==0)?'iconfont icon-zhedie1':'']" @click.stop.prevent="moreshow(index)"></i>
                                </span>
                            </span>
                        </template>

                    </dd>

                    <dd v-if="isteaview">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('learner',true)}}&nbsp;
                        </span><fflearner :k="103" :options="{'schid':item.id}"></fflearner>
                    </dd>
                </dl>
            </div>

            <div class="ffpage">
                <el-pagination :small="issmall" v-if="res.recordcount>res.ps" :background="true" :current-page.sync="res.cpage" :page-size="res.ps" layout=" prev, pager, next" :total="res.recordcount" @current-change="getdata">
                </el-pagination>
            </div>
        </div>

        <div class="memnorecord" v-else>{{$common.dicword('norecord')}}</div>
    </div>

</template>


<script>
    import { mixinsubpage } from "@/mixin/mixin"

    export default {
        name: 'Ctest',
        mixins: [mixinsubpage],
        data() {
            return {
                postact: 'tc_my_test'
            };
        },
        methods: {
            getdata: function () {
                this.$common.post(this.postjson, res => {

                    this.$common.each(res.infodata, item => {
                        this.$common.each(res.infodatacourse, (item) => {
                            item.x_root = this.$common.tranlearnfolder(item.typekv);
                        });
                        item.x_course = this.$common.basic.fffind(res.infodatacourse, 'id', item.courseid);
                        item.x_mem = {}
                        item.x_isexam = true;
                        item.x_mem = this.$common.basic.fffind(res.infodatamem, 'schid', item.id);
                        if (this.$common.basic.isobjexist(item.x_mem)) {
                            item.x_isexam = item.x_mem.isexam == 1;
                        }

                        item.x_statitem = {};
                        let statitem = this.$common.basic.fffind(res.infodatastat, 'kv', item.finalstat);
                        if (this.$common.basic.isobjexist(statitem)) {
                            item.x_statitem = statitem;
                        }

                        let groupids = item.groupids.split(',');
                        let _groups = [];
                        this.$common.each(groupids, (item) => {
                            let cgroup = this.$common.basic.fffind(res.infodatagroup, 'id', item);
                            if (this.$common.basic.isobjexist(cgroup)) {
                                _groups.push(cgroup);
                            }
                        });
                        item.x_groups = _groups;
                        item.x_groupshow = false;
                    });

                    this.isload = true;
                    this.infolist = res.infodata;
                    this.res = res;
                });

            },
            moreshow: function (v) {
                this.$common.each(this.infolist, (item, index) => {
                    if (v == index) {
                        item.x_groupshow = !item.x_groupshow;
                    }
                    else {
                        item.x_groupshow = false;
                    }
                });
            },
            gototest: function (id) {
                this.$common.confirm('confrimentertest', () => {
                    let jsondata = { 'postdata': { 'act': 'tc_my_test_go', 'id': id } };
                    this.$common.post(jsondata, res => {
                        window.location = this.$common.basic.mydecode(res.url);
                    });
                })

            }
        }
    }
</script>
